const isHiddenLayoutRoutes = [
    '/generate-qr',
    '/qr-content',
    '/capture',
    '/masterpass-3d',
    '/payment-3d',
    '/cash-respond',
]

export default isHiddenLayoutRoutes
